import { s as store } from './pes-router-store-0c1092be.js';

const navigateWithRouter = (route, target = document) => {
  const routerEvent = new CustomEvent('pesLinkClick', {
    detail: route,
    bubbles: true,
    composed: true,
    cancelable: true,
  });
  target.dispatchEvent(routerEvent);
};
const isAppRoutingEnabled = () => {
  return store.get('enableAppRouting');
};
const getCustomProductCTAs = () => {
  return store.get('productCTAs');
};
const getCustomAddToCartSettings = () => {
  var _a, _b;
  return (_b = (_a = getCustomProductCTAs()) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.cart;
};
const getCustomAddToFavoritesSettings = () => {
  var _a, _b;
  return (_b = (_a = getCustomProductCTAs()) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.favorites;
};
const getIsCustomAddToCartEnabled = () => {
  var _a;
  return !!((_a = getCustomAddToCartSettings()) === null || _a === void 0 ? void 0 : _a.isShown);
};
const getIsCustomAddToFavoritesEnabled = () => {
  var _a;
  return !!((_a = getCustomAddToFavoritesSettings()) === null || _a === void 0 ? void 0 : _a.isShown);
};
const getIsProductsInCustomCart = (productIds) => {
  return productIds.every((productId) => {
    var _a, _b;
    return !!((_b = (_a = getCustomAddToCartSettings()) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.includes(productId));
  });
};
const getIsProductsInCustomFavorites = (productIds) => {
  return productIds.every((productId) => {
    var _a, _b;
    return !!((_b = (_a = getCustomAddToFavoritesSettings()) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.includes(productId));
  });
};
const getIsCustomPriceEnabled = () => {
  return store.get('showCustomPrice');
};
const getCustomPrice = () => {
  return store.get('customPrice');
};

export { getIsProductsInCustomCart as a, getIsCustomAddToFavoritesEnabled as b, getIsProductsInCustomFavorites as c, getCustomAddToCartSettings as d, getCustomAddToFavoritesSettings as e, getIsCustomPriceEnabled as f, getIsCustomAddToCartEnabled as g, getCustomPrice as h, isAppRoutingEnabled as i, getCustomProductCTAs as j, navigateWithRouter as n };
